export default {
  methods: {
    nextFocus (refId) {
      setTimeout(() => {
        this.$refs[refId].focus()
      }, 100);
    }
  }
}